import { SVGProps } from 'react'

export const UploadErrorSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 21 16' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M13.5.5a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H.5A.5.5 0 0 1 0 11V1A.5.5 0 0 1 .5.5h13Zm-3.232 2.232a2.504 2.504 0 0 0-3.538 0L4.027 5.434A.093.093 0 0 0 4 5.501c0 .025.01.049.027.066l.382.382a.093.093 0 0 0 .132 0l2.702-2.702c.336-.336.782-.52 1.256-.52.475 0 .92.184 1.255.52.336.336.52.782.52 1.256 0 .475-.184.92-.52 1.256L7 8.514l-.446.447A1.07 1.07 0 0 1 5.04 7.448l2.732-2.734a.365.365 0 0 1 .258-.106h.001a.361.361 0 0 1 .256.62L6.054 7.461a.093.093 0 0 0-.026.067c0 .024.009.048.026.066l.383.382a.093.093 0 0 0 .131 0l2.233-2.234c.206-.206.319-.48.319-.77a1.092 1.092 0 0 0-1.862-.77l-.265.265-2.467 2.467c-.34.34-.526.79-.526 1.271A1.793 1.793 0 0 0 5.797 10c.46 0 .92-.175 1.27-.525l3.2-3.202A2.492 2.492 0 0 0 11 4.503a2.484 2.484 0 0 0-.732-1.77Z'
        fill='currentColor'
        fillRule='nonzero'
        opacity='.45'
      />
      <path
        d='M20.416 13.906a.625.625 0 0 1-.541.938h-9.75a.625.625 0 0 1-.541-.938l4.874-8.436c.114-.2.32-.314.542-.314a.62.62 0 0 1 .541.313l4.875 8.437Z'
        fill='#FFF'
        stroke='#FFF'
        strokeWidth='.5'
      />
      <path
        d='m20.2 14.031-4.875-8.437A.37.37 0 0 0 15 5.406a.37.37 0 0 0-.325.188L9.8 14.03a.375.375 0 0 0 .325.563h9.75a.375.375 0 0 0 .325-.563Zm-5.575-5.156c0-.052.042-.094.094-.094h.562c.052 0 .094.042.094.094v2.156a.094.094 0 0 1-.094.094h-.562a.094.094 0 0 1-.094-.094V8.875ZM15 13a.563.563 0 1 1 0-1.125A.563.563 0 0 1 15 13Z'
        fill='#FAAD14'
        fillRule='nonzero'
      />
    </g>
  </svg>
)
